module.exports = __webpack_public_path__ + "img/itunes-2.4b81e19b.svg";